module.exports = __webpack_public_path__ + "static/img/exit-on-64px.c554101e.png";